import type { BaseViews } from "../../../types/react";
import type { PopUpAlignment, PopUpSide, PopUpViews } from "../types";

export const DEFAULT_VIEW: BaseViews | PopUpViews = "primary";
export const DEFAULT_SIDE: PopUpSide = "top";
export const DEFAULT_ALIGNMENT: PopUpAlignment = "center";
export const DEFAULT_WIDTH: number = 240;
export const DEFAULT_ADJUSTMENT_LOCKED: boolean = false;
export const POPUP_ROLE: React.AriaRole = "tooltip";
export const POPUP_ARIA_LIVE: React.AriaAttributes["aria-live"] = "polite";
export const POPUP_TEST_ID: string = "popup-test-id";
